module.exports = function () {

  var theClass = 'form-headline-mobile hidden-desktop';
  var theClass1 = 'form-headline-mobile just-regiojet';
  var sharedOptions = {
    id: 'studentagency.cz',
    hostname: '//olymp9.sa.cz/shared/'

  };
  var options = {
    letenky: {
      maxRoutes: 5,
      formType: 'round_trip',
      header: {
        text: 'Letenky',
        className: theClass
      }
    },
    jizdenky: {
      header: {
        text: 'Jízdenky',
        className: theClass1
      }
    },
    ubytovani: {
      header: {
        text: 'Ubytování',
        className: theClass
      }
    },
    pojisteni: {
      header: {
        text: 'Pojištění',
        className: theClass
      }
    },
    auta: {
      header: {
        text: 'Pronájem aut',
        className: theClass
      }
    },
    jazykovePobyty: {
      header: {
        text: 'Jazykové pobyty',
        className: theClass
      }
    },
    pracovniPobyty: {
      header: {
        text: 'Pracovní pobyty',
        className: theClass
      }
    },
    dovolena: {
      header: {
        text: 'Dovolená',
        className: theClass
      }
    }
  };

  Object.keys(options).forEach((key) => {
    options[key] = $.extend({}, sharedOptions, options[key]);
  });

  return options;

};
